import React from 'react';
import ProductItemDetails from './ProductItemDetails';
import ServicesItemDetails from './ServicesItemDetails';
import { useSalesContext } from '../../../context/sales_context';




const ItemDetails = (props) => {

  const {
    type
  } = useSalesContext();

  return (
    <>
      {type === 'product' ?
        <ProductItemDetails /> :
        <ServicesItemDetails />
      }
    </>
  );
};

export default ItemDetails;
